(function ($) {


    $.fn.msxicheckhider = function (options) {
        // build main options before element iteration
        var opts = $.extend({}, $.fn.msxicheckhider.defaults, options);

        return this.each(function () {
            var $this = $(this);

            // build element specific options
            var eOpts = $.metadata ? $.extend({}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend({}, eOpts, $this.dataset()) : eOpts;

            var parentForm = $this.closest(".form");
            var verticalForm = parentForm.length > 0 && parentForm.hasClass('orientation-vertical');
            // Only apply to vertical forms at the moment
            if (verticalForm) {
                $this.checkhider({
                    checkboxParent: eOpts.checkboxParent,
                    hideLongerThan: (eOpts.checkHiderShowMin + eOpts.checkHiderHideMin)-1,
                    hideMin: eOpts.checkHiderHideMin,
                    showFirst: eOpts.checkHiderShowMin,
                    hideChecked: eOpts.hideChecked,
                    expandClass: eOpts.expandClass,
                    collapseClass: eOpts.collapseClass
                });
            }
        });
    };

    $.fn.msxicheckhider.defaults = {
        'checkHiderShowMin' : 4,  // never hides more than the first n items
        'checkHiderHideMin' : 2, // Don't hide less than this number of items
        'checkboxParent':'.form-checkbox', // The parent container for the checkbox (show/hide will be called on this)
        'hideChecked': true, // Set to false to always show checked items, no matter how many there are
        'expandClass':'ui-icon ui-icon-secondary ui-icon-triangle-1-s', // icon class for expand
        'collapseClass':'ui-icon ui-icon-secondary ui-icon-triangle-1-n' // icon class for contract
    };

})(jQuery);